import React, { Component } from 'react';
import './pages.css';

import Button from './button.js';

require('./Fonts/691970/0a9b9cc6-55eb-4369-97ed-87b3eefd433a.woff2');
require('./Fonts/691979/84e1d9b2-4a5e-42f7-b7bb-e9edadb46977.woff2');

class MainPage extends Component {
  render() {
    const { changePage } = this.props;

    return (
      <div className="mainpage">
        <div className="maincontent">
            <div className="header-bar">
                <div>
                    <img className="logo-title" src={require('./images/main/title.svg')} />
                </div>
                <div className="button-bar">
                    <Button changePage={changePage} pageName="character" innerClassName="btn-medium" containerClassName="character-btn-container" buttonFile={require('./images/buttonc.svg')} caption="Character Design"/>
                    <Button changePage={changePage} pageName="animation" innerClassName="btn-large" containerClassName="animation-btn-container" buttonFile={require('./images/buttona.svg')} caption="Animation"/>
                    <Button changePage={changePage} pageName="graphic" innerClassName="btn-large" containerClassName="graphic-btn-container" buttonFile={require('./images/buttong.svg')} caption="Graphic Design"/>
                    <Button changePage={changePage} pageName="uxui" innerClassName="btn-medium" containerClassName="uxui-btn-container" buttonFile={require('./images/buttonu.svg')} caption="UX/UI Design"/>
                </div>
            </div>
            <div className="heading-right darker">
                <h1>Designer extraordinaire!</h1>
            </div>
            <div className="heading-bar-right">
                <img class="fullsite" src={require('./images/main/bm2.jpg')}/>
            </div>
            <div className="centered-full medium">
                <p>From animation to design, I'm a wiz at digital art! I'm an expert when it comes to just about any Adobe program, a fantastic learner when it comes to anything new, and I'm great at both independent and collaborative work.</p>
                <p>Need proof? Keep reading!</p>
            </div>
            <div className="animation-section">
                <div className="animation-heading light">
                    <h2>Animation &amp; Character Design</h2>
                </div>
                <div className="animation light">
                    <p>I'll admit it, I'm a sucker for animation. This fascinating craft has captivated me since I was young, and I've spent the majority of my life studying and practicing it.</p>
                    <p>Character design is where my talents really flourish, though I also have experience in both 2D and 3D development.</p>
                </div>
                <img className="animation-1" src={require('./images/main/mb1.png')} />
                <img className="animation-2" src={require('./images/main/mb2.png')} />
                <Button changePage={changePage} pageName="character" containerClassName="character-btn-inline" buttonFile={require('./images/buttonc.svg')} caption="Character Design"/>
                <Button changePage={changePage} pageName="animation" containerClassName="animation-btn-inline" buttonFile={require('./images/buttona.svg')} caption="Animation"/>
            </div>
            <div className="graphic-section">
                <div className="graphic-heading darker">
                    <h2>Graphic &amp; UX/UI Design</h2>
                </div>
                <div className="graphic dark">
                    <p>I did say I was a design wiz, didn't I? I have years of experience with a good feel for graphic and UX/UI design. Feel free to throw me a design challenge, and I'll show you what I can do!</p>
                </div>
                <img className="graphic-1" src={require('./images/main/mb3.png')} />
                <Button changePage={changePage} pageName="graphic" containerClassName="graphic-btn-inline" buttonFile={require('./images/buttong.svg')} caption="Graphic Design"/>
                <Button changePage={changePage} pageName="uxui" containerClassName="uxui-btn-inline" buttonFile={require('./images/buttonu.svg')} caption="UX/UI Design"/>
            </div>
            <div className="contact-section">
                <div className="contact-heading light">
                    <h1>Want more?</h1>
                </div>
                <div className="contact light">
                    email: <a href="mailto:christina.b.winchester@gmail.com">christina.b.winchester@gmail.com</a><br/>
                    phone: (801) 361-1375 <br/>
                    instagram: <a href="https://www.instagram.com/foxheartfinds">@foxheartfinds</a>
                </div>
                <a href="https://www.linkedin.com/in/christina-winchester-34335a102"><img className="linkedin" src={require('./images/main/buttons/mb4.png')} /></a>
                <a href="https://www.etsy.com/shop/FoxHeartFinds"><img className="etsy" src={require('./images/main/buttons/mb5.png')} /></a>
            </div>
            <div className="copyright-info">
                © Christina Winchester; 2019
            </div>
        </div>
      </div>
    );
  }
}

export default MainPage;
